// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./fonts/poppins-regular-webfont.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./fonts/poppins-regular-webfont.woff2", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: "poppinsregular";
    src:
        url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff2"),
        url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff");
    font-weight: normal;
    font-style: normal;
}

body {
    margin: 0;
    font-family: "poppinsregular" !important;
    background-color: #c9dbf7 !important;
    padding: 0 !important;
}

code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New", monospace;
}

.text-input[type="text"] {
    border: 0.5px solid #005eef;
}
.text-input[type="text"]:focus {
    border: 0.5px solid #005eef;
    outline: none;
}

/*scrollbar css start*/
/* width */
::-webkit-scrollbar {
    /* width: 5px; */
}

/* Track */
::-webkit-scrollbar-track {
    width: 5px;
}

/* Handle */
::-webkit-scrollbar-thumb {
    background: rgb(156, 156, 156);
    width: 5px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
    background: rgb(158, 158, 158);
}

/* Font Size */
.text-xxs {
    font-size: 0.63rem;
    line-height: 0.75rem;
}
.text-xs {
    font-size: 0.75rem;
    line-height: 1rem;
}

.text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
}

.text-base {
    font-size: 1rem;
    line-height: 1.5rem;
}

.text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
}

.text-xl-1 {
    font-size: 1.125rem;
    line-height: 1.75rem;
}

.text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
}

.text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
}

.text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
}

.text-4xl {
    font-size: 2.25rem;
    line-height: 2.5rem;
}

.text-5xl {
    font-size: 3rem;
    line-height: 1rem;
}

.text-6xl {
    font-size: 3.75rem;
    line-height: 1rem;
}

/* Font Weight */
.text-bold-6 {
    font-weight: 600;
}

.text-bold-7 {
    font-weight: 700;
}

.text-bold-8 {
    font-weight: 800;
}

/* text alignment */
.text-center {
    text-align: center;
}

.text-right {
    text-align: right;
}

.text-left {
    text-align: left;
}

/* letter spacing */
.l-spacing-1 {
    letter-spacing: 1px;
}

.l-spacing-2 {
    letter-spacing: 2px;
}

.l-spacing-3 {
    letter-spacing: 3px;
}

.l-spacing-4 {
    letter-spacing: 4px;
}

.l-spacing-5 {
    letter-spacing: 5px;
}

/* Colors */
.background-color-blue {
    background-color: #005eef !important;
}

.background-color-white {
    background-color: #ffffff;
}

.text-upper-case {
    text-transform: uppercase;
}

.vertical-center {
    position: relative;
    top: 50%;
    transform: translateY(-50%);
}

.box-shadow--full-container {
    box-shadow: 0px 0px 4px 0px rgba(17, 17, 26, 0.18);
}

.box-shadow--cards {
    box-shadow:
        rgba(0, 0, 0, 0.16) 0px 10px 36px 0px,
        rgba(0, 0, 0, 0.06) 0px 0px 0px 1px;
}

.box-shadow--2 {
    box-shadow: 0px 0px 4px 0px rgba(17, 17, 26, 0.18);
}

.box-shadow--3 {
    box-shadow: 0px 0px 12px 1px #fff;
}

.custom-btn-center-container {
    display: flex;
    justify-content: center;
}

.custom-btn {
    text-transform: unset !important;
    padding: 2px 20px !important;
}

.custom-btn--upload-reset {
    margin: 10px 10px 0px 10px !important;
    font-size: 11px !important;
}

.custom-btn-outlined {
    color: #005eef !important;
    border-color: var() !important;
}

.custom-btn-action-standard {
    color: rgba(0, 0, 0, 0.6) !important;
    border-color: var() !important;
}
.ag-floating-filter-button {
    display: none !important;
}

.ag-header-cell-menu-button {
    opacity: 1 !important;
    cursor: pointer;
}

.ag-theme-alpine {
    --ag-foreground-color: #4d4d4d !important;
    --ag-header-foreground-color: #005eef !important;
    --ag-header-column-resize-handle-color: #005eef !important;
    --ag-font-family: "poppinsregular" !important;
    --ag-font-size: 14px !important;
}

.hidden {
    display: none !important;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;IACI,6BAA6B;IAC7B;;8DAE+D;IAC/D,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,wCAAwC;IACxC,oCAAoC;IACpC,qBAAqB;AACzB;;AAEA;IACI,+EAA+E;AACnF;;AAEA;IACI,2BAA2B;AAC/B;AACA;IACI,2BAA2B;IAC3B,aAAa;AACjB;;AAEA,sBAAsB;AACtB,UAAU;AACV;IACI,gBAAgB;AACpB;;AAEA,UAAU;AACV;IACI,UAAU;AACd;;AAEA,WAAW;AACX;IACI,8BAA8B;IAC9B,UAAU;AACd;;AAEA,oBAAoB;AACpB;IACI,8BAA8B;AAClC;;AAEA,cAAc;AACd;IACI,kBAAkB;IAClB,oBAAoB;AACxB;AACA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA,gBAAgB;AAChB;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA,mBAAmB;AACnB;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA,mBAAmB;AACnB;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,WAAW;AACX;IACI,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IAER,2BAA2B;AAC/B;;AAEA;IACI,kDAAkD;AACtD;;AAEA;IACI;;2CAEuC;AAC3C;;AAEA;IACI,kDAAkD;AACtD;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,gCAAgC;IAChC,4BAA4B;AAChC;;AAEA;IACI,qCAAqC;IACrC,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;IACzB,8BAA8B;AAClC;;AAEA;IACI,oCAAoC;IACpC,8BAA8B;AAClC;AACA;IACI,wBAAwB;AAC5B;;AAEA;IACI,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,yCAAyC;IACzC,gDAAgD;IAChD,0DAA0D;IAC1D,6CAA6C;IAC7C,+BAA+B;AACnC;;AAEA;IACI,wBAAwB;AAC5B","sourcesContent":["@font-face {\n    font-family: \"poppinsregular\";\n    src:\n        url(\"./fonts/poppins-regular-webfont.woff\") format(\"woff2\"),\n        url(\"./fonts/poppins-regular-webfont.woff2\") format(\"woff\");\n    font-weight: normal;\n    font-style: normal;\n}\n\nbody {\n    margin: 0;\n    font-family: \"poppinsregular\" !important;\n    background-color: #c9dbf7 !important;\n    padding: 0 !important;\n}\n\ncode {\n    font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\", monospace;\n}\n\n.text-input[type=\"text\"] {\n    border: 0.5px solid #005eef;\n}\n.text-input[type=\"text\"]:focus {\n    border: 0.5px solid #005eef;\n    outline: none;\n}\n\n/*scrollbar css start*/\n/* width */\n::-webkit-scrollbar {\n    /* width: 5px; */\n}\n\n/* Track */\n::-webkit-scrollbar-track {\n    width: 5px;\n}\n\n/* Handle */\n::-webkit-scrollbar-thumb {\n    background: rgb(156, 156, 156);\n    width: 5px;\n}\n\n/* Handle on hover */\n::-webkit-scrollbar-thumb:hover {\n    background: rgb(158, 158, 158);\n}\n\n/* Font Size */\n.text-xxs {\n    font-size: 0.63rem;\n    line-height: 0.75rem;\n}\n.text-xs {\n    font-size: 0.75rem;\n    line-height: 1rem;\n}\n\n.text-sm {\n    font-size: 0.875rem;\n    line-height: 1.25rem;\n}\n\n.text-base {\n    font-size: 1rem;\n    line-height: 1.5rem;\n}\n\n.text-lg {\n    font-size: 1.125rem;\n    line-height: 1.75rem;\n}\n\n.text-xl-1 {\n    font-size: 1.125rem;\n    line-height: 1.75rem;\n}\n\n.text-xl {\n    font-size: 1.25rem;\n    line-height: 1.75rem;\n}\n\n.text-2xl {\n    font-size: 1.5rem;\n    line-height: 2rem;\n}\n\n.text-3xl {\n    font-size: 1.875rem;\n    line-height: 2.25rem;\n}\n\n.text-4xl {\n    font-size: 2.25rem;\n    line-height: 2.5rem;\n}\n\n.text-5xl {\n    font-size: 3rem;\n    line-height: 1rem;\n}\n\n.text-6xl {\n    font-size: 3.75rem;\n    line-height: 1rem;\n}\n\n/* Font Weight */\n.text-bold-6 {\n    font-weight: 600;\n}\n\n.text-bold-7 {\n    font-weight: 700;\n}\n\n.text-bold-8 {\n    font-weight: 800;\n}\n\n/* text alignment */\n.text-center {\n    text-align: center;\n}\n\n.text-right {\n    text-align: right;\n}\n\n.text-left {\n    text-align: left;\n}\n\n/* letter spacing */\n.l-spacing-1 {\n    letter-spacing: 1px;\n}\n\n.l-spacing-2 {\n    letter-spacing: 2px;\n}\n\n.l-spacing-3 {\n    letter-spacing: 3px;\n}\n\n.l-spacing-4 {\n    letter-spacing: 4px;\n}\n\n.l-spacing-5 {\n    letter-spacing: 5px;\n}\n\n/* Colors */\n.background-color-blue {\n    background-color: #005eef !important;\n}\n\n.background-color-white {\n    background-color: #ffffff;\n}\n\n.text-upper-case {\n    text-transform: uppercase;\n}\n\n.vertical-center {\n    position: relative;\n    top: 50%;\n    -ms-transform: translateY(-50%);\n    transform: translateY(-50%);\n}\n\n.box-shadow--full-container {\n    box-shadow: 0px 0px 4px 0px rgba(17, 17, 26, 0.18);\n}\n\n.box-shadow--cards {\n    box-shadow:\n        rgba(0, 0, 0, 0.16) 0px 10px 36px 0px,\n        rgba(0, 0, 0, 0.06) 0px 0px 0px 1px;\n}\n\n.box-shadow--2 {\n    box-shadow: 0px 0px 4px 0px rgba(17, 17, 26, 0.18);\n}\n\n.box-shadow--3 {\n    box-shadow: 0px 0px 12px 1px #fff;\n}\n\n.custom-btn-center-container {\n    display: flex;\n    justify-content: center;\n}\n\n.custom-btn {\n    text-transform: unset !important;\n    padding: 2px 20px !important;\n}\n\n.custom-btn--upload-reset {\n    margin: 10px 10px 0px 10px !important;\n    font-size: 11px !important;\n}\n\n.custom-btn-outlined {\n    color: #005eef !important;\n    border-color: var() !important;\n}\n\n.custom-btn-action-standard {\n    color: rgba(0, 0, 0, 0.6) !important;\n    border-color: var() !important;\n}\n.ag-floating-filter-button {\n    display: none !important;\n}\n\n.ag-header-cell-menu-button {\n    opacity: 1 !important;\n    cursor: pointer;\n}\n\n.ag-theme-alpine {\n    --ag-foreground-color: #4d4d4d !important;\n    --ag-header-foreground-color: #005eef !important;\n    --ag-header-column-resize-handle-color: #005eef !important;\n    --ag-font-family: \"poppinsregular\" !important;\n    --ag-font-size: 14px !important;\n}\n\n.hidden {\n    display: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
